<section class="participants">
    @if (!isNextRaces) {
        <div [ngClass]="{ 'participant-racingpost': !isOptionBet }">
            <ms-racingpost-pick [fixture]="fixture" [tab]="'raceWinner'"></ms-racingpost-pick>
        </div>
    }
    @if (!isNextRaces) {
        <div class="win-sort-header">
            @if (isRunnerInfo) {
                <button ds-button kind="utility" variant="flat-reduced" size="medium" (click)="toggleExpandCollapse()">
                    <vn-icon slot="start" [name]="!isAllexpanded ? 'theme-down' : 'theme-up'" />
                    {{ isAllexpanded ? sitecore.horseRacing.raceDetails.CollapseAll : sitecore.horseRacing.raceDetails.ExpandAll }}
                </button>
            }

            <div class="header-sort">
                <ms-dropdown
                    [activeOption]="activeOption"
                    [isIconTemplate]="true"
                    [options]="dropDownItems"
                    (optionChange)="orderBy($event.id)"
                    (dropdownState)="trackDropdownToggle($event)"
                    ><vn-icon icon name="sports-greyhounds-sorting" size="16"></vn-icon>
                </ms-dropdown>
            </div>
        </div>
    }

    @for (runner of participants; track $index) {
        <div class="greyhound-participant-wrapper">
            <div
                [ngClass]="
                    vm.expandedParticipant[runner.id]
                        ? 'greyhound-participant clearfix expanded-greyhound-participant'
                        : 'greyhound-participant clearfix'
                ">
                <div>
                    <div class="greyhound-runner-info">
                        @if (!runner.attributes.isFavorite) {
                            <div class="trap-images">
                                <ms-gh-trap-images
                                    [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                                    [isOptionBet]="isOptionBet"
                                    [participant]="runner"></ms-gh-trap-images>
                                @if (
                                    !isNextRaces &&
                                    !isTrapWinner &&
                                    (runner.racingPostInfo?.greyhoundsData.spotlightComment ||
                                        runner.racingPostInfo?.greyhoundsData.topSpeed ||
                                        runner.racingPostInfo?.greyhoundsData.starRating)
                                ) {
                                    <div class="sports-icon">
                                        <button ds-button-icon variant="flat-reduced" kind="tertiary" size="small" (click)="toggleRunnerInfo(runner)">
                                            <vn-icon
                                                height="12"
                                                width="12"
                                                [name]="vm.expandedParticipant[runner.id] ? 'theme-up' : 'theme-down'"></vn-icon>
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        <div class="greyhound-name-group runner-info-item">
                            <span [ngClass]="runner.attributes.isFavorite ? 'runner-name-title runner-favorite' : 'runner-name-title'">
                                @if (runner.properties?.type === 'Trap' && isTrapWinner) {
                                    {{ sitecore.greyhoundRacing.messages.TrapNumber | msInterpolate: { trapNumber: runner.participantId } }}
                                } @else if (runner.attributes.isFavorite) {
                                    {{ sitecore.greyhoundRacing.messages.Favourite }}
                                } @else if (isOptionBet) {
                                    {{ this.greyhoundTrapDogMapping[runner.participantId].greyhoundName }}
                                } @else {
                                    {{ runner.properties?.greyhound || (runner.name | msTranslate) }}
                                }
                            </span>

                            @if (!isTrapWinner) {
                                @if (runner.attributes.trainer) {
                                    <span class="greyhound-trainer-name">
                                        <strong class="trainer">{{ sitecore.horseRacing.common.TrainerNamePrefix }}</strong>
                                        {{ runner.attributes.trainer || runner?.properties?.Trainer }}
                                    </span>
                                }
                                @if (runner.racingPostInfo?.greyhoundsData.form) {
                                    <span class="greyhound-trainer-name"
                                        ><strong class="form">{{ sitecore.horseRacing.common.Form }}</strong>
                                        {{ runner.racingPostInfo?.greyhoundsData.form }}</span
                                    >
                                }
                            }
                        </div>
                    </div>
                    <div class="pick-wrapper">
                        <div class="greyhound-odds">
                            @if (isOptionBet) {
                                <ms-hr-option-pick
                                    class="odds-info ms-selectable-pick"
                                    *ngIf="runner.option"
                                    [option]="runner.option"
                                    [optionGroup]="optionGroup"
                                    [event]="fixture"
                                    [participant]="runner"
                                    [pickType]="pickType"
                                    [checkSiblingSelected]="true"
                                    [trackingSource]="getTrackingSource(optionPickTrackingsource, runner)"
                                    [trackingModuleType]="trackingModuleType"
                                    [trackingOptions]="getTrackingOptions(fixture, runner)">
                                    @if (runner.option.online) {
                                        <div>
                                            <span>
                                                @switch (runner.option.participantPriceType) {
                                                    @case (priceType.Fixed) {
                                                        <span class="option-value">
                                                            {{ runner.option.nativePrice | msExternalPriceFormatter }}
                                                        </span>
                                                    }
                                                    @case (priceType.StartingPrice) {
                                                        <span>{{ sitecore.betslip.messages.StartingPrice }}</span>
                                                    }
                                                }
                                            </span>
                                        </div>
                                    }
                                    @if (!runner.option.online) {
                                        <div class="lock odds-info"><vn-icon class="lock-icon" name="theme-locked-i" size="12"></vn-icon></div>
                                    }
                                </ms-hr-option-pick>
                            } @else {
                                <ms-fixture-pick
                                    class="greyhound-odds-info ms-selectable-pick"
                                    *ngIf="runner.option"
                                    [fixture]="fixture"
                                    [participant]="runner"
                                    [option]="runner.option"
                                    [enablePriceTypeCheck]="true"
                                    [trackingSource]="trackingSource"
                                    [trackingOptions]="getTrackingOptions(fixture, runner)">
                                    <ms-racing-fixture-container
                                        [runner]="runner"
                                        [isSports]="true"
                                        [isGreyhounds]="true"
                                        [isSpan]="true"
                                        [isOption]="true"
                                        [isWinMarketOdds]="true"
                                        [isActive]="runner.isOptionActive"></ms-racing-fixture-container>
                                </ms-fixture-pick>
                            }
                            @if (runner.isOptionActive) {
                                <div class="previous-odds">
                                    @for (price of runner.priceHistory; track $index) {
                                        <span>{{ price | msExternalPriceFormatter }}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            @if (vm.expandedParticipant[runner.id] && !runner.attributes.isFavorite) {
                <div class="greyhound-show-more">
                    <div class="greyhound-spotlight">
                        @if (runner.racingPostInfo?.greyhoundsData.spotlightComment) {
                            <span class="diomed">
                                {{ runner.racingPostInfo?.greyhoundsData.spotlightComment }}
                            </span>
                        }
                    </div>
                    <div class="topSpeed-star-rating">
                        @if (runner.racingPostInfo?.greyhoundsData.topSpeed) {
                            <div class="greyhound-topSpeed">
                                {{ sitecore.horseRacing.raceDetails.TopSpeed }} {{ runner.racingPostInfo?.greyhoundsData.topSpeed }}
                            </div>
                        }
                        @if (runner.racingPostInfo?.greyhoundsData.starRating) {
                            <div class="greyhound-rating-group rating">
                                <ms-star-rating [rating]="runner.racingPostInfo?.greyhoundsData.starRating"></ms-star-rating>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @if (vm.nonRunners.length && !isNextRaces) {
        <section class="greyhound-non-runners">
            <span class="non-runners-header">{{ sitecore.horseRacing.raceDetails.NonRunners }}</span>
            <span class="non-runners">{{ vm.nonRunners }}</span>
        </section>
    }
</section>
